import React, { ChangeEvent } from 'react';

import { ControlledTextFieldProps } from '../../../components/TextField/ControlledTextField';
import MaskedTextField from '../../../components/TextField/MaskedTextField';

const DateOfBirthTextField = (props: ControlledTextFieldProps) => (
  <MaskedTextField
    mask="##/##/####"
    placeholder="MM/DD/YYYY"
    definitions={{
      '#': /[0-9]/,
    }}
    onAccept={(value: any) => {
      return (
        props.onChange &&
        props.onChange({
          target: { name: props.name, value },
        } as ChangeEvent<HTMLInputElement>)
      );
    }}
    style={{
      fontKerning: 'none',
    }}
    overwrite
    // There is known bug with the react-imask library and the typings when using their mixin with custom Input components
    {...(props as any)}
  />
);

export default DateOfBirthTextField;
